export default "__VITE_ASSET__CD5TM8Um__"